<template>
  <div>
    <Chargebee />
    <AddonDialog
      :show="addonDialogOpen"
      :show-coupon-disclaimer="true"
      :addon-target="addonTarget"
      @cancel="onCancel"
      @continue="onContinue"
    />
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import Chargebee from '@/components/payments/Chargebee.vue';
import { SMART_PLAN, US_SMART_PLAN } from '../payments/data/constants';
import AddonDialog from '../payments/AddonDialog.vue';
import purgeResource from '@/api/payments';

export default {
  name: 'CouponDialog',

  components: {
    Chargebee,
    AddonDialog,
  },

  data() {
    return {
      addonTarget: SMART_PLAN,
      success: false,
    };
  },

  computed: {
    ...mapGetters('chargebee', ['isInTrial']),
    ...mapGetters('subscription', ['isDeputter', 'isSyngenta']),
    ...mapState('subscription', ['province']),
    ...mapState('discountCoupon', ['activeSubscriptionCoupon', 'addonDialogOpen']),
  },

  methods: {
    ...mapActions('subscription', ['convertSubscriptionToFarmLink']),
    ...mapActions('app', ['acquireMimicLock', 'releaseMimicLock']),
    ...mapMutations('discountCoupon', ['setAddonDialogOpen']),

    async onClose() {
      if (this.success) {
        await purgeResource(['subscription', 'estimate']);
        if (this.isDeputter || this.isSyngenta) {
          await this.convertSubscriptionToFarmLink();
          await this.releaseMimicLock();
        }
        window.location.reload();
      } else {
        await this.releaseMimicLock();
      }
    },

    onSuccess() {
      this.success = true;
    },

    onCancel() {
      this.setAddonDialogOpen(false);
    },

    async onContinue(addons) {
      await this.acquireMimicLock();
      this.$chargebee.openCheckout({
        plan: SMART_PLAN,
        isMonthly: false,
        addons,
        endTrial: this.isInTrial,
        coupon: this.activeSubscriptionCoupon.coupon_id,
        callbacks: {
          close: this.onClose,
          success: this.onSuccess,
        },
      });
      this.setAddonDialogOpen(false);
    },
  },
};
</script>
